import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";

// Components
import Header from "./components/Header";
import HeroSection from "./components/HeroSection";
import CasaPremiumSection from "./components/CasaPremiumSection";
import SuitesSection from "./components/SuitesSection";
import EventosSection from "./components/EventosSection";
import PasseiosSection from "./components/PasseiosSection";
import GastronomiaSection from "./components/GastronomiaSection";
import MotoristaSection from "./components/MotoristaSection";
import DepoimentosSection from "./components/DepoimentosSection";
import FAQSection from "./components/FAQSection";
import ContatoSection from "./components/ContatoSection";
import Footer from "./components/Footer";
import WhatsAppFloat from "./components/WhatsAppFloat";

// Pages
import CasaPremiumPage from "./pages/CasaPremiumPage";
import MamuskaClubPage from "./pages/MamuskaClubPage";

// Landing Page Component
const LandingPage = () => {
  return (
    <>
      <Header />
      <main>
        <HeroSection />
        <CasaPremiumSection />
        <SuitesSection />
        <EventosSection />
        <PasseiosSection />
        <GastronomiaSection />
        <MotoristaSection />
        <DepoimentosSection />
        <FAQSection />
        <ContatoSection />
      </main>
      <Footer />
      <WhatsAppFloat />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <Toaster position="top-center" richColors />
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/casa-premium/itanhanga-luxury-villa" element={<CasaPremiumPage />} />
          <Route path="/eventos/mamuska-club" element={<MamuskaClubPage />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
